module.exports = __webpack_public_path__ + "img/Unidad8-1.67291890.png";